export const AUTH_ENABLED = (() => {
  const raw = process.env.REACT_APP_AUTH_ENABLED;
  // 默认开启登录；如需关闭可显式设置 REACT_APP_AUTH_ENABLED=false
  if (raw == null) return true;
  const normalized = String(raw).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on';
})();
